import { CommunityJournals } from "@/components/recommendations/CommunityJournals";
import AppLayout from "@/components/layout/AppLayout";
import { useAuth } from "@/contexts/AuthContext";
import { useScrollIndicator } from "@/hooks/useScrollIndicator";
import { useIsTabletOrMobile } from "@/hooks/use-tablet-mobile";

const ExplorePage = () => {
  const { user } = useAuth();
  const isTabletOrMobile = useIsTabletOrMobile();
  const { isScrolling, handleScroll } = useScrollIndicator();

  return (
    <AppLayout pageTitle="Explore - StudiBudi">
      <div className={`h-full bg-app-background flex flex-col min-h-0 overflow-y-auto ${isScrolling ? 'scrollbar-thin-light' : 'scrollbar-hide'}`} onScroll={handleScroll}>
        <div className={`h-full flex ${isTabletOrMobile ? 'flex-col' : 'flex-row'} gap-6 md:gap-8 p-4 md:p-6 lg:p-8 overflow-y-auto`}>
          {/* Main Content */}
          <div className={`${isTabletOrMobile ? 'w-full' : 'flex-1'} min-w-0 space-y-8`}>
            {/* Welcome Greeting - Minimal Design */}
            <div className="py-6 flex items-center justify-center">
              <div className="w-full px-3 text-center">
                <img
                  src="/lovable-uploads/efa2905b-bb1d-40a6-8600-de4c01056bcd.png"
                  alt="Waving hand"
                  className="w-[72px] h-[72px] mx-auto mb-4"
                />
                <h1 className="text-[32px] font-medium text-slate-900 mb-1">
                  Explore Journals
                </h1>
                <p className="text-[20px] text-slate-500 mb-2">
                  Discover community journals and copy them to your workspace
                </p>
              </div>
            </div>

            {/* Community Journals Section */}
            <CommunityJournals />

            {/* Footer */}
            <footer className="pt-12 pb-8 text-center border-t border-slate-100 mt-12">
              <p className="text-sm text-slate-400">
                © {new Date().getFullYear()} StudiBudi. All rights reserved.
              </p>
            </footer>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default ExplorePage;